module.exports = __webpack_public_path__ + "img/avatar.ef7d8fb6.png";